import { Alert, Box, Button, DialogActions, DialogContent, DialogTitle, Grid, LinearProgress, Paper, Snackbar, SnackbarCloseReason } from '@mui/material';
import { useState } from 'react';
import { AutoCompleteFazenda, IVFormErrors, VForm, useVForm } from '../../../shared/forms';
import * as yup from 'yup';
import { RelatorioService } from '../../../shared/services/api/rh/Relatorios/RelatoriosService';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs, { Dayjs } from 'dayjs';
import { AutoCompleteProdutividade } from '../../../shared/forms/AutoCompleteProdutividade';
import RelatorioProdutividade from './RelatorioProdutividade';

interface IFomeTipoPgto {
  idfazenda: string;
  idproducao: string;
}

const formValidationSchema: yup.ObjectSchema<IFomeTipoPgto> = yup.object().shape({
  idfazenda: yup.string().required(),
  idproducao: yup.string().optional().default(''),
});

export const RdiarioProdutividade: React.FC = () => {
  const { formRef, save } = useVForm();
  const [isLoading, setIsLoading] = useState(false);
  const [openmsg, setOpenmsg] = useState(false);
  const [fazenda, setFazenda] = useState('');
  const [inicial, setInicial] = useState<Dayjs | null>(dayjs());
  const [final, setFinal] = useState<Dayjs | null>(dayjs());
  const [msg, setMsg] = useState('');
  const [tms, setTms] = useState<'warning' | 'error' | 'info' | 'success'>('warning');

  const handleCloseMsg = (
    event?: React.SyntheticEvent | Event,
    reason?: SnackbarCloseReason,
  ) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenmsg(false);
  };

  const handleSave = (dados: IFomeTipoPgto) => {
    formValidationSchema.
      validate(dados, { abortEarly: false })
      .then((dadosValidados) => {
        setIsLoading(true);
        RelatorioService
          .rprodutividadediario(dadosValidados.idfazenda, dadosValidados.idproducao, dayjs(inicial).format('DD/MM/YYYY'), dayjs(final).format('DD/MM/YYYY'))
          .then((result) => {
            setIsLoading(false);
            if (result instanceof Error) {
              setTms('error');
              setMsg(result.message);
              setOpenmsg(true);
            } else {
              const periodo = `${dayjs(inicial).format('DD/MM/YYYY')} a ${dayjs(final).format('DD/MM/YYYY')}`;
              RelatorioProdutividade(result, fazenda, periodo)
                .catch(() => {
                  setTms('error');    
                  setMsg('Não foi possível gerar o relatório.');
                  setOpenmsg(true);
                });    
            }
          });     
      })
      .catch((errors: yup.ValidationError) => {
        const validationErrors: IVFormErrors = {};
        errors.inner.forEach(error => {
          if (!error.path) return;
          validationErrors[error.path] = error.message;
        });
        formRef.current?.setErrors(validationErrors);
      });
  };

  const handleFazenda = (nome: string | undefined) => {
    if (nome != null) {
      setFazenda(nome);
    } else {
      setFazenda('');
    }
  };

  return (
    <VForm ref={formRef} onSubmit={handleSave}>
      <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'center' }} open={openmsg} autoHideDuration={900} onClose={handleCloseMsg}>
        <Alert
          onClose={handleCloseMsg}
          severity={tms}
          variant="filled"
          sx={{ width: '100%' }}
        >
          {msg}
        </Alert>
      </Snackbar>
      <Box alignItems="center" width='auto' alignContent='center' height="auto" display="flex" flexDirection="column"  >
        <Box gap={1} padding={1} paddingX={2} display="flex" alignItems="center" alignSelf='center' width='100%' height="100%" margin={1} alignContent='center'></Box>
        <Box width='auto' alignItems="center" component={Paper} height="auto" margin={1}
          alignContent='center'>
          <DialogTitle>Relatório de Produtividade Diaria</DialogTitle>
          <DialogContent dividers>
            {isLoading && (
              <Grid item>
                <LinearProgress variant='indeterminate' />
              </Grid>
            )}
            <Grid container padding={1} item direction="row" gap={2}>
              <Grid container spacing={2} item direction="row" xs={12} sm={12} md={12} lg={12} xl={12}>
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                  <AutoCompleteFazenda
                    isExternalLoading={isLoading}
                    nome={handleFazenda}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                  <AutoCompleteProdutividade
                    isExternalLoading={isLoading}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={4} xl={4}>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      format='DD/MM/YYYY'
                      value={inicial}
                      onChange={(newValue) => setInicial(newValue)}
                      label='Data Inicial'
                      slotProps={{
                        textField: {
                          size: 'small',
                        }
                      }}
                    />
                  </LocalizationProvider>
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={4} xl={4}>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      format='DD/MM/YYYY'
                      value={final}
                      onChange={(newValue) => setFinal(newValue)}
                      label='Data Final'
                      slotProps={{
                        textField: {
                          size: 'small',
                        }
                      }}
                    />
                  </LocalizationProvider>
                </Grid>
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button sx={{ minWidth: '30%' }} variant='outlined' autoFocus onClick={save}>Visualizar</Button>
          </DialogActions>
        </Box>

      </Box>
    </VForm>
  );
};   